import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  HTMLSelect,
  ITagProps,
  Label,
  Switch,
  Tag,
} from '@blueprintjs/core';
import { Businesses, Users } from '@just-in-types';
import * as React from 'react';
import { connect } from 'react-redux';
import { firestore } from '../firebase';
import { roles, userHasAccount } from '../globals';
import { IState } from '../store';
import InspectorButton from './InspectorButton';
import SitePicker, { Selected } from './SitePicker';

interface UserOwnProps {
  user: Users.User | Users.UserWithAccount;
}

interface UserStateProps {
  businesses: Businesses.Business[];
}

type UserProps = UserOwnProps & UserStateProps;

interface UserState {
  businessOptions: { [key: string]: { id: string; path: string } };
  businesses: string[];
  changed: boolean;
  role: Users.Role;
  selectedBusiness: { businessId: null | string; businessPath: null | string };
  showUserDialog: boolean;
  sites: string[];
  updating: boolean;
  isDashboard: boolean;
  ismask: boolean;
  isSiteDisplay: boolean;
  isVoidCheckIn: boolean;
  selectedTearApartSiteId: { siteId: null | string; sitePath: null | string };
  tearApartSiteId: string | null | false;
}

class User extends React.Component<UserProps, UserState> {
  public state: UserState = {
    businessOptions: {},
    businesses: [],
    changed: false,
    isDashboard: this.props.user.accountData && this.props.user.accountData.permissions.isDashboard === true
    ? true : false,
    isSiteDisplay:false,
    isVoidCheckIn: this.props.user.accountData && this.props.user.accountData.permissions.isVoidCheckIn === true
    ? true : false,
    ismask: this.props.user.accountData && this.props.user.accountData.permissions.ismask === true
    ? true : false,
    role: 'user',
    selectedBusiness: { businessId: null, businessPath: null },
    showUserDialog: false,
    sites: [],
    updating: false,
    selectedTearApartSiteId: { siteId: null, sitePath: null },
    tearApartSiteId: this.props.user.accountData && this.props.user.accountData.permissions.tearApartSiteId ? this.props.user.accountData.permissions.tearApartSiteId : null,
  };

  public componentDidMount() {
    this.processUser();
    this.buildBusinessOptions();
  }

  public componentDidUpdate({
    businesses: prevBusinesses,
    user: prevUser,
  }: UserProps) {
    const { businesses, user } = this.props;

    if (prevBusinesses.length !== businesses.length) {
      this.buildBusinessOptions();
    }

    if (prevUser.userId !== user.userId) {
      this.processUser();
    }
  }

  public render() {
    const { user } = this.props;


    const {
      businessOptions,
      businesses,
      changed,
      isDashboard,
      ismask,
      isVoidCheckIn,
      role,
      selectedBusiness: { businessId, businessPath },
      showUserDialog,
      updating,
    } = this.state;

    const tearApartUsers = user.accountData && ( user.accountData.email === 'alexa@tearapart.com' || user.accountData.email === 'slcrewards@tearapart.com' || user.accountData.email === 'mariah@tearapart.com' || user.accountData.email === 'ogdenrewards@tearapart.com' ) ? true : false;

    const addBusinessDisabled =
      !businessId || !businessPath || businesses.indexOf(businessId) >= 0;
    const businessTags = businesses
      .filter(business => businessOptions[business])
      .map((business, index) => {
        const path = businessOptions[business].path;

        return (
          <>
            <div style={{ display:"flex" }}>
              <Tag
                id={business}
                intent="danger"
                key={index}
                large={true}
                onRemove={this.removeBusiness}
                style={{ margin: '0.25rem 0' }}>
                {path}
              </Tag>
                { tearApartUsers && this.state.tearApartSiteId && business === 'gBHr1GdJSlpASgUvkoLW'?
                  <Tag
                  intent="danger"
                  large={true}
                  style={{ margin: '0.25rem' }}
                  >
                    {this.state.tearApartSiteId}
                  </Tag>
                  :
                  ("")
                }
            </div>
          </>
        );
      });

    return (
      <tr>
        <td>
          <Button
            icon="edit"
            intent="primary"
            minimal={true}
            onClick={this.toggleUserDialog}
          />
        </td>
        <td>
          {user.name && user.name.firstname && user.name.lastname
            ? `${user.name.firstname} ${user.name.lastname}`
            : ''}
        </td>
        <td>{user.accountData ? user.accountData.email : ''}</td>
        <td>{user.mobile || ''}</td>
        <td>{role}</td>
        {process.env.NODE_ENV === 'development' && (
          <td>
            <InspectorButton content={user} />
          </td>
        )}
        <Dialog
          canEscapeKeyClose={true}
          canOutsideClickClose={true}
          isCloseButtonShown={true}
          isOpen={showUserDialog}
          onClose={this.toggleUserDialog}
          title="edit user">
          <div className={Classes.DIALOG_BODY}>
            <div id="user-style">
              <FormGroup label="role">
                <HTMLSelect
                  onChange={this.handleRoleSelect}
                  options={roles}
                  value={role}
                />
              </FormGroup>
            </div>
            <div>
              <Switch label="Sensitive Data Mask" checked={ ismask } onChange={this.handleSensitiveDataMask} />
            </div>  
            {role === 'admin'?
            <div>
              <Switch label="Enable Dashboard Page" checked={ isDashboard } onChange={this.handleDashboard} />
            </div>
            :''  
            }
            {role === 'admin' || role === 'owner'?
            <div>
              <Switch label="Enable Void check-in" checked={ isVoidCheckIn } onChange={this.handleVoidCkeckIn} />
            </div>
            :''  
            }
            <Label>business permissions</Label>
            <div style={{ display: 'flex' }} id="buss-permission-style">
              <SitePicker
                hideSites={tearApartUsers && this.state.isSiteDisplay?false:true}
                filter={true}
                onSelect={this.handleSitePicker}
              />
              <Button
                disabled={addBusinessDisabled}
                icon="plus"
                intent="success"
                onClick={this.addBusiness}
              />
            </div>
            <div
              style={{
                alignItems: 'flex-start',
                display: 'flex',
                flexDirection: 'column',
              }}>
              {businessTags}
            </div>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button minimal={true} onClick={this.toggleUserDialog}>
                cancel
              </Button>
              <Button
                disabled={!changed}
                intent="primary"
                loading={updating}
                onClick={this.updateUser}>
                update
              </Button>
            </div>
          </div>
        </Dialog>
      </tr>
    );
  }

  private handleSensitiveDataMask = () =>{
    this.setState({ changed: true, ismask: !this.state.ismask });
  }
  private handleDashboard = () =>{
    this.setState({ changed: true, isDashboard: !this.state.isDashboard });
  }

  private handleVoidCkeckIn = () =>{
    this.setState({ changed: true, isVoidCheckIn: !this.state.isVoidCheckIn });
  }

  private processUser = () => {
    const { user: userOfUnknownType } = this.props;
    const user = userHasAccount(userOfUnknownType) ? userOfUnknownType : null;

    if (user) {
      const { permissions } = user.accountData;
      const businesses = permissions.businesses || [];
      const sites = permissions.sites || [];

      const role =
        user.accountData && user.accountData.permissions
          ? (user.accountData.permissions.role as Users.Role)
          : 'user';

      this.setState({ businesses, role, sites });
    }
  };

  private buildBusinessOptions = () => {
    const { businesses } = this.props;
    const businessOptions: { [key: string]: { id: string; path: string } } = {};

    businesses.forEach(
      ({ businessId, path }) =>
        (businessOptions[businessId] = { id: businessId, path }),
    );

    this.setState({ businessOptions });
  };

  private toggleUserDialog = () =>
    this.setState(({ showUserDialog }) => ({
      showUserDialog: !showUserDialog,
    }));

  private handleRoleSelect = ({
    currentTarget: { value },
  }: React.ChangeEvent<HTMLSelectElement>) => {
    const role = value as Users.Role;

    this.setState({ changed: true, role });
  };

  private handleSitePicker = ({ businessId, businessPath, siteId, sitePath }: Selected) => {
    if(businessId === 'gBHr1GdJSlpASgUvkoLW'){
      this.setState({ isSiteDisplay : true, selectedTearApartSiteId : {siteId, sitePath} });
    }else{
      this.setState({ isSiteDisplay : false });
    }
    this.setState({ selectedBusiness: { businessId, businessPath } });
  };

  private addBusiness = () => {
    const {
      businesses,
      selectedBusiness: { businessId },
      selectedTearApartSiteId: { siteId },
    } = this.state;

    if (businessId) {
      this.setState({ businesses: [...businesses, businessId], tearApartSiteId: siteId, changed: true });
    }
  };

  private removeBusiness = (
    event: React.MouseEvent<HTMLButtonElement>,
    { id }: ITagProps,
  ) => {
    const { businesses } = this.state;

    if (id) {
      this.setState({
        businesses: businesses.filter(businessId => businessId !== id),
        changed: true,
      });
    }
  };

  private updateUser = async () => {
    const {
      user: { userId },
    } = this.props;
    const { businesses, role, sites, ismask, isDashboard, isVoidCheckIn, tearApartSiteId } = this.state;

    this.setState({ updating: true });
    const tearApartUsers = this.props.user.accountData && ( this.props.user.accountData.email === 'alexa@tearapart.com' || this.props.user.accountData.email === 'slcrewards@tearapart.com' || this.props.user.accountData.email === 'mariah@tearapart.com' || this.props.user.accountData.email === 'ogdenrewards@tearapart.com' ) ? true : false;

    console.log('updateUser', ismask);

    try {
      if( tearApartUsers && tearApartSiteId){
        await firestore
        .collection('users')
        .doc(userId)
        .update({
          'accountData.permissions.businesses': businesses,
          'accountData.permissions.isDashboard':isDashboard,
          'accountData.permissions.isVoidCheckIn':isVoidCheckIn,
          'accountData.permissions.ismask':ismask,
          'accountData.permissions.role': role,
          'accountData.permissions.sites': sites,
          'accountData.permissions.tearApartSiteId': tearApartSiteId,
        });

      }else{
        await firestore
        .collection('users')
        .doc(userId)
        .update({
          'accountData.permissions.businesses': businesses,
          'accountData.permissions.isDashboard':isDashboard,
          'accountData.permissions.isVoidCheckIn':isVoidCheckIn,
          'accountData.permissions.ismask':ismask,
          'accountData.permissions.role': role,
          'accountData.permissions.sites': sites,
        });
      }

    } catch (error) {
      throw new Error(error);
    }

    this.setState({ changed: false, updating: false });
  };
}

export const mapStateToProps = ({ businesses: { businesses } }: IState) => ({
  businesses,
});

export default connect(mapStateToProps)(User);



// WEBPACK FOOTER //
// ./src/components/User.tsx